export const positions = [
  "Mechanical Engineer",
  "Electrical Engineer",
  "Civil Engineer",
  "Instrumentation Engineer",
  "Control Systems Engineer",
  "Site Supervisor",
  "Project Manager",
  "Maintenance Technician",
  "Safety Officer",
  "Quality Control Engineer",
  "Boiler Operator",
  "Plant Operator"
];

export const benefits = [
  {
    title: "Health Insurance",
    description: "Comprehensive medical coverage for you and your family"
  },
  {
    title: "PF & ESI",
    description: "Provident Fund and Employee State Insurance benefits"
  },
  {
    title: "Training Programs",
    description: "Regular skill development and technical training"
  },
  {
    title: "Career Growth",
    description: "Clear career progression paths and promotions"
  },
  {
    title: "Accommodation",
    description: "Housing facilities at project sites (where applicable)"
  },
  {
    title: "Team Culture",
    description: "Collaborative and supportive work environment"
  }
];